import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "gfu-installments-summary" }
const _hoisted_2 = { class: "_ttu _tc--lighter _mt-0 _mb-1" }
const _hoisted_3 = { class: "_fw-b _tc--base" }
const _hoisted_4 = { class: "gfu-installments-summary__values-list" }
const _hoisted_5 = { class: "_flex" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_progress_bar = _resolveComponent("progress-bar")
  const _component_summary_list_item = _resolveComponent("summary-list-item")
  const _component_base_button = _resolveComponent("base-button")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_remaining_installments_payment_modal = _resolveComponent("remaining-installments-payment-modal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.Resources.YourPledge.RemainingInstallmentsBoxTitle), 1 /* TEXT */),
    _createElementVNode("span", _hoisted_3, _toDisplayString($options.installmentsProgressBarHeader), 1 /* TEXT */),
    _createVNode(_component_progress_bar, {
      value: $props.numberOfCompletedPayments,
      max: $props.numberOfInstallments,
      "progression-class": "gfu-progress-bar__progression--accent"
    }, null, 8 /* PROPS */, ["value", "max"]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.installmentsSummaryListData, (summaryListItem) => {
        return (_openBlock(), _createBlock(_component_summary_list_item, _mergeProps({ ref_for: true }, summaryListItem, {
          key: summaryListItem.title
        }), null, 16 /* FULL_PROPS */))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_tooltip, {
        text: $options.buttonTooltipText,
        enabled: !!$options.buttonTooltipText
      }, {
        default: _withCtx(() => [
          ($options.isPaymentAvailable)
            ? (_openBlock(), _createBlock(_component_base_button, {
                key: 0,
                class: "_mt-1",
                width: "wide",
                theme: "accent",
                disabled: $options.isPayRemainingButtonDisabled,
                onClick: $options.onPayAllRemaining,
                "data-qa": "StretchPay:payRemaining"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($options.remainingAmountToPay), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["disabled", "onClick"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["text", "enabled"])
    ]),
    _createVNode(_component_remaining_installments_payment_modal, {
      "is-open": $data.isPayAllRemainingModalVisible,
      "order-code": $props.orderCode,
      "remaining-amount": $options.formattedRemainingAmount,
      "installment-plan-id": $props.installmentPlanId,
      onModalClose: $options.onModalClose,
      onInstallmentsPaid: $options.onInstallmentsPaid
    }, null, 8 /* PROPS */, ["is-open", "order-code", "remaining-amount", "installment-plan-id", "onModalClose", "onInstallmentsPaid"])
  ]))
}